const inIframe = function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

const getParameters = function getParameters(url) {
    //Params obj
    var params = {};
    //To lowercase
    // url = url.toLowerCase();
    //To array
    url =  url.replace(process.env.VUE_APP_REDIRECT_URI +'?','')
     url = url.split('&');

    //Iterate over url parameters array
    var length = url.length;
    for (var i = 0; i < length; i++) {
        //Create prop
        var prop = url[i].slice(0, url[i].search('='));
        //Create Val
        var value = url[i].slice(url[i].search('=')).replace('=', '');
        //Params New Attr
        params[prop] = value;
    }

    return params;
}

export {
    getParameters,
    inIframe
}